"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var req_1 = __importDefault(require("./req"));
function not(arg) {
    if (typeof arg === 'function') {
        return function (value) { return !arg(value); };
    }
    return !arg;
}
function isNil(value) {
    return value === undefined || value === null;
}
function isValidInputObject(obj) {
    return Object.keys(obj).length > 1;
}
function uploadFileReducer(state, action) {
    switch (action.type) {
        case 'REGISTER': {
            var newState = state.filter(isValidInputObject);
            return __spreadArrays(newState, [{}]);
        }
        case 'UNREGISTER': {
            var _a = state[action.payload], request = _a.request, data = _a.data;
            if (request && !data) {
                request.cancel();
                return state.filter(function (_, index) { return index !== action.payload; });
            }
            if (request && data) {
                var newFiles = __spreadArrays(state);
                newFiles[action.payload].request.cancelled = true;
                return newFiles;
            }
            return state.filter(function (_, index) { return index !== action.payload; });
        }
        case 'DELETE': {
            return state.filter(function (_, index) { return index !== action.payload; });
        }
        case 'TARGET': {
            var _b = action.payload, ref = _b.ref, index = _b.index;
            if (ref && !state[index].ref) {
                ref.click();
                var newFiles = __spreadArrays(state);
                newFiles[index].ref = ref;
                return newFiles;
            }
            return state;
        }
        case 'UPDATE': {
            var _c = action.payload, index = _c.index, valid = _c.valid, error = _c.error, file = _c.file;
            var newFiles = __spreadArrays(state);
            newFiles[index].file = file;
            newFiles[index].valid = valid;
            newFiles[index].error = error;
            newFiles[index].progress = 0;
            newFiles[index].done = false;
            newFiles[index].failed = false;
            return newFiles;
        }
        case 'UPDATE_DATA': {
            var _d = action.payload, index_1 = _d.index, props_1 = _d.props;
            return state.map(function (uploadData, currentIndex) {
                if (currentIndex === index_1) {
                    return __assign(__assign({}, uploadData), { data: __assign(__assign({}, uploadData.data), props_1) });
                }
                return uploadData;
            });
        }
        case 'START': {
            var _e = action.payload, request = _e.request, index = _e.index;
            var newFiles = __spreadArrays(state);
            newFiles[index].request = request;
            newFiles[index].request.cancelled = false;
            return newFiles;
        }
        case 'PROGRESS': {
            var _f = action.payload, progress = _f.progress, index = _f.index;
            var newFiles = __spreadArrays(state);
            newFiles[index].progress = progress;
            return newFiles;
        }
        case 'FAILURE': {
            var _g = action.payload, error = _g.error, index = _g.index;
            var newFiles = __spreadArrays(state);
            newFiles[index].error = error;
            newFiles[index].failed = true;
            return newFiles;
        }
        case 'RETRY': {
            var newFiles = __spreadArrays(state);
            newFiles[action.payload].request = undefined;
            newFiles[action.payload].error = undefined;
            newFiles[action.payload].failed = false;
            newFiles[action.payload].done = false;
            newFiles[action.payload].progress = 0;
            return newFiles;
        }
        case 'FINISH': {
            var _h = action.payload, data = _h.data, index = _h.index;
            var newFiles = __spreadArrays(state);
            newFiles[index].done = true;
            newFiles[index].data = data;
            return newFiles;
        }
        default: {
            return state;
        }
    }
}
function useFileUpload(options) {
    var accept = options.accept, fileSize = options.fileSize, url = options.url, token = options.token, onChange = options.onChange;
    var _a = react_1.useReducer(function (state, action) { return uploadFileReducer(state, action); }, []), uploads = _a[0], dispatch = _a[1];
    var makeUpload = function (upload, index) {
        var request = req_1.default.upload(url, { file: upload.file }, {
            token: token,
            onUploadProgress: function (progressEvent) {
                var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                dispatch({ type: 'PROGRESS', payload: { index: index, progress: progress } });
            },
        });
        request.promise.then(function (data) {
            dispatch({ type: 'FINISH', payload: { index: index, data: data } });
        });
        request.promise.catch(function (error) {
            if (!error.cancelled) {
                dispatch({
                    type: 'FAILURE',
                    payload: { index: index, error: 'Falha no upload do arquivo. Tente novamente.' },
                });
            }
        });
        dispatch({ type: 'START', payload: { index: index, request: request } });
    };
    var makeDelete = function (upload, index) {
        req_1.default.delete(url, { token: token, data: { path: upload.data.path } }).then(function () {
            dispatch({ type: 'DELETE', payload: index });
        });
    };
    var isFormatValid = function (file) { return accept.length === 0 || accept.includes(file.type); };
    var isSizeValid = function (file) { return fileSize === 0 || file.size / (1024 * 1024) <= fileSize; };
    react_1.useEffect(function () {
        uploads.forEach(function (upload, index) {
            if (!upload.request && upload.file && upload.valid) {
                makeUpload(upload, index);
            }
            if (upload.request && upload.data && upload.request.cancelled) {
                makeDelete(upload, index);
            }
        });
    }, [uploads]);
    react_1.useEffect(function () {
        var newUploads = uploads.filter(isValidInputObject);
        var done = newUploads.every(function (upload) { return upload.done; });
        var valid = newUploads.every(function (upload) { return upload.valid; });
        var value = newUploads.map(function (_a) {
            var data = _a.data;
            return data;
        }).filter(not(isNil));
        onChange === null || onChange === void 0 ? void 0 : onChange(value, { valid: valid, done: done, empty: newUploads.length === 0 });
    }, [uploads]);
    return {
        uploads: uploads,
        add: function () {
            dispatch({ type: 'REGISTER' });
        },
        cancel: function (index) {
            dispatch({ type: 'UNREGISTER', payload: index });
        },
        retry: function (index) {
            dispatch({ type: 'RETRY', payload: index });
        },
        loadInput: function (index) {
            return function (ref) {
                dispatch({ type: 'TARGET', payload: { index: index, ref: ref } });
            };
        },
        updateData: function (index, props) {
            dispatch({
                type: 'UPDATE_DATA',
                payload: { index: index, props: props },
            });
        },
        handleInput: function (index) {
            return function (event) {
                var _a;
                var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a.item(0);
                var isDuplicated = uploads.find(function (upload) { var _a; return ((_a = upload === null || upload === void 0 ? void 0 : upload.file) === null || _a === void 0 ? void 0 : _a.name) === (file === null || file === void 0 ? void 0 : file.name); });
                if (!file || isDuplicated) {
                    dispatch({ type: 'UNREGISTER', payload: index });
                    return;
                }
                var valid = true;
                var error;
                if (!isFormatValid(file)) {
                    valid = false;
                    error = 'Formato não aceito';
                }
                else if (!isSizeValid(file)) {
                    valid = false;
                    error = "Arquivo maior do que " + fileSize + "mb";
                }
                dispatch({
                    type: 'UPDATE',
                    payload: { index: index, file: file, valid: valid, error: error },
                });
            };
        },
    };
}
exports.default = useFileUpload;
